import { ANY_ROOM_TYPE } from 'pages/common/consts/rooms';

export const hasMatchingRoomType = ({
  itemRoomType,
  roomType,
}: {
  itemRoomType: string | undefined;
  roomType: string;
}): boolean => {
  if (itemRoomType === undefined && roomType === ANY_ROOM_TYPE) return true;
  return itemRoomType === roomType;
};
